/** TODO This is to support percentage rollout of SSG. It can be removed when we've rolled out SSG to 100% of users. */
export const sanitizeStaticPath = (pathname: string) =>
  pathname.replace('/_static', '');
